export default [
  {
    value: 'en',
    label: 'English',
  },
  {
    value: 'pt-br',
    label: 'Brazilian Portuguese',
  },
  {
    value: 'ru',
    label: 'Russian',
  },
  {
    value: 'fr',
    label: 'French',
  },
  {
    value: 'es-la',
    label: 'Spanish (Latin America)',
  },
  {
    value: 'pl',
    label: 'Polish',
  },
  {
    value: 'tr',
    label: 'Turkish',
  },
  {
    value: 'it',
    label: 'Italian',
  },
];
